import { render, staticRenderFns } from "./UserTypes.vue?vue&type=template&id=7c33d32a&"
import script from "./UserTypes.vue?vue&type=script&lang=js&"
export * from "./UserTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports